import { kebabCase } from '@shared/helpers/kebabCase';

export const slugify = (str: string) => kebabCase(str).replace(/\./g, '-');
